import script from "./AccountIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__